import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitokhandalataxifare() {



  const cardData = {
    keyword: " Mumbai to Khandala Taxi Fare",


"headingDescription": "Royal Route Cab offers reliable and affordable Mumbai to Khandala taxi services, ensuring a smooth, safe, and comfortable journey for families, couples, and weekend travelers. Khandala is one of the most popular hill stations near Mumbai, known for its lush green valleys, misty mountains, waterfalls, and scenic viewpoints, making it a perfect quick getaway from city life. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Khandala route covers approximately 80 to 90 km and takes around 1.5 to 2.5 hours depending on traffic conditions and monsoon season rush. Taxi fares generally start from around ₹1,500 to ₹2,500 for hatchbacks and can go up to ₹3,500 to ₹5,500+ for SUVs depending on vehicle type, season, tolls, and travel time. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Khandala travel.",

"topPlaces": [
  {
    "title": "Khandala Ghat Viewpoints",
    "description": "Khandala Ghat Viewpoints are among the most iconic attractions on the Mumbai–Pune highway stretch, offering breathtaking panoramic views of deep valleys, winding roads, and mist-covered Sahyadri mountains. During monsoon season, the entire region transforms into a lush green paradise with flowing waterfalls and low-hanging clouds, making it one of the most scenic driving routes in Maharashtra. Travelers often stop here for photography, tea breaks, and to enjoy the cool mountain breeze that makes the journey unforgettable."
  },
  {
    "title": "Tiger’s Leap (Khandala)",
    "description": "Tiger’s Leap is a famous cliff-top viewpoint that resembles a leaping tiger when viewed from a distance. It offers dramatic views of steep valleys, dense forests, and echoing winds that create a thrilling natural experience. The site is especially popular during sunrise and monsoon when fog and clouds move through the valleys, giving visitors a surreal and almost cinematic landscape perfect for photography and relaxation."
  },
  {
    "title": "Bhushi Dam (Nearby Lonavala-Khandala Belt)",
    "description": "Bhushi Dam is a major monsoon attraction located close to Khandala, famous for water overflowing over stone steps creating a natural waterfall effect. Visitors enjoy splashing in cold water, relaxing with friends, and experiencing the lively weekend crowd atmosphere. It is one of the most visited spots in the entire Lonavala-Khandala region, especially during peak rainy season when water flow is at its strongest."
  },
  {
    "title": "Rajmachi Fort Trek Route",
    "description": "Rajmachi Fort is a historic Maratha fort located between Lonavala and Khandala, known for its adventurous trekking routes through dense forests, waterfalls, and rocky trails. The trek is popular among adventure seekers and nature lovers, offering stunning views of Sahyadri ranges and valleys from the top. During monsoon, the entire route becomes lush green and filled with streams, making it one of the most rewarding trekking experiences near Mumbai."
  },
  {
    "title": "Kune Waterfall",
    "description": "Kune Waterfall is one of the tallest waterfalls in Maharashtra and a breathtaking natural attraction located near Khandala. Surrounded by green hills and cliffs, the waterfall becomes extremely powerful during monsoon season, creating a misty and refreshing atmosphere. Visitors often stop here for photography, relaxation, and enjoying the natural beauty of cascading water falling from great heights."
  },
  {
    "title": "Lion’s Point View",
    "description": "Lion’s Point is a popular viewpoint offering sweeping views of valleys, waterfalls, and dramatic mountain landscapes. It is a favorite stop for tourists traveling between Mumbai and Pune, especially during monsoon when clouds float below the viewpoint level. Small food stalls, tea vendors, and snack points nearby make it a lively yet scenic halt for travelers."
  },
  {
    "title": "Duke’s Nose (Nagphani Point)",
    "description": "Duke’s Nose, also known as Nagphani Point, is a striking cliff resembling a nose-like structure and is a popular trekking and adventure destination near Khandala. It offers panoramic views of the Western Ghats, deep valleys, and the expressway below. It is especially famous among trekkers, rock climbers, and photographers looking for dramatic natural scenery."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves dating back over 2,000 years, located near the Khandala–Lonavala region. Known for their grand chaitya hall and intricate carvings, these caves represent early Buddhist architecture and spiritual heritage. Visitors climb a series of steps to reach the caves while enjoying scenic views along the way."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a peaceful natural water body surrounded by green hills, becoming especially beautiful during monsoon when it fills with rainwater. It is a calm picnic spot ideal for families and couples looking to relax away from crowded tourist areas. The reflection of clouds and hills on the lake surface creates a serene and photogenic atmosphere."
  },
  {
    "title": "Shooting Point (Khandala)",
    "description": "Shooting Point in Khandala is a scenic location often used for film shoots due to its dramatic landscapes, rolling hills, and misty valleys. It offers a quiet and less crowded environment where travelers can enjoy peaceful nature walks, photography, and wide-angle views of the Western Ghats."
  }
],







services: [
  {
    name: "Mumbai to Khandala Cab",
    description: "Mumbai to Khandala cab service offers a quick and scenic journey to one of Maharashtra’s most popular hill destinations. The drive via the Mumbai-Pune Expressway is filled with lush greenery, waterfalls, and stunning valley views, especially during monsoon. Ideal for weekend trips, couples, families, and corporate outings, this service ensures safe and comfortable travel. Professional drivers and well-maintained vehicles enhance the experience. It guarantees a refreshing and hassle-free getaway."
  },
  {
    name: "Mumbai to Khandala Taxi",
    description: "Mumbai to Khandala taxi provides convenient and private travel with door-to-door pickup and drop. This service is perfect for travelers looking for a comfortable and flexible ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for short trips and hill station visits. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Khandala Cab Service",
    description: "Mumbai to Khandala cab service is designed for fast and reliable travel with a focus on comfort and safety. The route offers beautiful views and smooth highways, making the journey enjoyable. This service is ideal for families, couples, and group travel. Vehicles are maintained for performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Khandala Taxi Service",
    description: "Mumbai to Khandala taxi service offers dependable transportation with a focus on safety and comfort. This service is suitable for tourists, families, and corporate travelers. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy trip planning. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Khandala",
    description: "Cab from Mumbai to Khandala provides a personalized travel experience with flexible stops at scenic viewpoints. Travelers can enjoy a relaxed and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a memorable road trip experience."
  },
  {
    name: "Taxi from Mumbai to Khandala",
    description: "Taxi from Mumbai to Khandala offers a convenient and efficient way to travel to this hill station. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for weekend trips and short travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Khandala Cab Booking",
    description: "Mumbai to Khandala cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Khandala Taxi Booking Online",
    description: "Mumbai to Khandala taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Khandala Cab Price",
    description: "Mumbai to Khandala cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Khandala Taxi Fare",
    description: "Mumbai to Khandala taxi fare is designed to be affordable and competitive for short-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Khandala One Way Cab",
    description: "Mumbai to Khandala one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick getaways. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Khandala Round Trip Taxi",
    description: "Mumbai to Khandala round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Khandala Innova Cab",
    description: "Mumbai to Khandala Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group outings. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Khandala Ertiga Cab",
    description: "Mumbai to Khandala Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Khandala Sedan Cab",
    description: "Mumbai to Khandala sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Khandala SUV Taxi",
    description: "Mumbai to Khandala SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways and hilly routes. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Khandala Cab",
    description: "Cheap Mumbai to Khandala cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Khandala Taxi Service",
    description: "Best Mumbai to Khandala taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Khandala Cab", "Mumbai to Khandala Taxi"],
  ["Mumbai to Khandala Cab Service", "Mumbai to Khandala Taxi Service"],
  ["Cab from Mumbai to Khandala", "Taxi from Mumbai to Khandala"],
  ["Mumbai to Khandala Cab Booking", "Mumbai to Khandala Taxi Booking Online"],
  ["Mumbai to Khandala Cab Price", "Mumbai to Khandala Taxi Fare"],
  ["Mumbai to Khandala One Way Cab", "Mumbai to Khandala Round Trip Taxi"],
  ["Mumbai to Khandala Innova Cab", "Mumbai to Khandala Ertiga Cab"],
  ["Mumbai to Khandala Sedan Cab", "Mumbai to Khandala SUV Taxi"],
  ["Cheap Mumbai to Khandala Cab", "Best Mumbai to Khandala Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Mumbai to Khandala Taxi Fare",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Mumbai to Khandala taxi fare with competitive pricing, making it ideal for quick trips and weekend getaways."
  },
  {
    WhyChooseheading: "Fast & Comfortable Expressway Travel",
    WhyChoosedescription: "Enjoy smooth and fast travel via Mumbai–Pune Expressway with our experienced drivers ensuring safe and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear taxi fare details including tolls, driver allowance, and parking with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our Mumbai to Khandala taxi service is available 24/7, allowing flexible travel anytime for business or leisure."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, regularly cleaned, and well-maintained for a comfortable journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Fare Options",
    WhyChoosedescription: "Choose from one-way taxi fare or round-trip packages based on your travel needs and budget."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all group sizes."
  },
  {
    WhyChooseheading: "Trusted Short-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Khandala taxi bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "What is the taxi fare from Mumbai to Khandala?", answer: "Taxi fare starts from approximately ₹1,500 for sedan cars and varies based on vehicle type and travel plan." },
  { question: "Do you provide Mumbai to Khandala cab service?", answer: "Yes, Royal Route Cabs offers reliable taxi services from Mumbai to Khandala for one-way and round trips." },
  { question: "What is the distance between Mumbai and Khandala?", answer: "The distance is approximately 80 to 85 km and takes around 2 to 3 hours via expressway." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Khandala taxi service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Are toll charges included in fare?", answer: "Toll charges are usually included or clearly mentioned during booking with no hidden fees." },
  { question: "Can I book a one-way taxi?", answer: "Yes, we provide both one-way and round-trip taxi services." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel times." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback: "Our Mumbai to Khandala trip with Royal Route Cabs was very pleasant. The booking process was simple and the ride was smooth with a courteous driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Desai",
    feedback: "Great experience traveling from Mumbai to Khandala. The cab was clean, punctual, and the journey was comfortable throughout with Royal Route Cabs.",
    rating: 5
  }
];



















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Taxi Fare",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-khandala-cab.jpg", // replace if needed
  "description": "Book Mumbai to Khandala taxi with Royal Route Cabs for a quick and comfortable hill station ride. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel with 24x7 reliable service and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-khandala-taxi-fare"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Khandala Taxi Fare | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Khandala taxi at best fare with Royal Route Cabs. One-way & round-trip cab service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to khandala cab, mumbai to khandala taxi, mumbai to khandala cab service, mumbai to khandala taxi service, cab from mumbai to khandala, taxi from mumbai to khandala, mumbai to khandala cab booking, mumbai to khandala taxi booking online, mumbai to khandala cab price, mumbai to khandala taxi fare, mumbai to khandala one way cab, mumbai to khandala round trip taxi, mumbai to khandala innova cab, mumbai to khandala ertiga cab, mumbai to khandala sedan cab, mumbai to khandala suv taxi, cheap mumbai to khandala cab, best mumbai to khandala taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokhandalataxifare;